import React, { ReactNode } from "react";
import SearchWidgetTabs from "../../searchwidgetTabs/searchWidgetTabs";
import { MaterialIcon } from "../../icon";
import ImageV2 from "../../image/image.v2";
import TabContent from "./tabcontent";
import type { SearchWidgetFullControlProps, SearchWidgetFullControlState, TabContentProps } from "./types";
import type { TabSlot } from "src/modules/bookingWidget/types";
import { getLanguageField } from "src/utils/language";


export default class SearchWidgetFullControl extends React.Component<SearchWidgetFullControlProps, SearchWidgetFullControlState> {
  state: SearchWidgetFullControlState = {
    tab: 0,
    days: 1,
    startDate: undefined,
    endDate: undefined,
    adults: 1,
    children: 0,
    ages: undefined,
    selectedOption: 0
  }

  get tab_colors() {
    return {
      element_border_color: this.props.item.element_border_color?.value,
      element_background_color: this.props.item.element_background_color?.value,
      element_text_color: this.props.item.element_text_color?.value,
      element_placeholder_text_color: this.props.item.element_placeholder_text_color?.value,
      bg_color: this.props.item.active_tab_background_color?.value,
      cta_button_bg_color: this.props.item.cta_button_background_color?.value,
      cta_button_hover_bg_color: this.props.item.cta_button_hover_background_color?.value,
      cta_button_label_color: this.props.item.cta_button_label_color?.value,
      cta_button_hover_label_color: this.props.item.cta_button_hover_label_color?.value,
    }
  }

  isLastTab(index:number){
    let tabs = 0;
    if (this.props.item.tab_slot_1) tabs++;
    if (this.props.item.tab_slot_2) tabs++;
    if (this.props.item.tab_slot_3) tabs++;
    if (this.props.item.tab_slot_4) tabs++;
    if (index === tabs) return true;
    return false;
  }

  tabContentProps(slot: TabSlot): TabContentProps {
    return {
      tab_slot: slot,
      language: this.props.selectedLanguage,
      default_language: this.props.defaultLanguage,
      ...this.tab_colors
    }
  }

  renderTabIcon(tab_slot: TabSlot, isSelected: boolean): ReactNode {
    let icon = <></>
    if (tab_slot.icon === "material") icon = <MaterialIcon className="w-6 h-6" icon={tab_slot.material_icon} />;
    if (tab_slot.icon === "custom") icon = <ImageV2 onlyStroke asSvgIcon src={tab_slot.icon_image?.imageFile} className={`w-6 h-6`} />
    return icon;
  }

  render() {
    return <>
      <div className={`${this.props.removeMargin ? "" : "mt-[-88px]"} flex w-full justify-between lg:px-10 relative z-[2] flex-col`}>
        <div className="w-[95%] sm:max-w-[400px] lg:max-w-6xl justify-center m-auto flex flex-col">
          <SearchWidgetTabs
            activeTabLineColor={this.props.item.divider_line_color?.value}
            activeFocusTextColor={this.props.item.active_tab_text_color?.value}
            activeFocusBackgroundColor={this.props.item.active_tab_background_color?.value}
            desktopActiveTabTextColor={this.props.item.active_tab_text_color?.value}
            desktopActiveTabBackgroundColor={this.props.item.active_tab_background_color?.value}
            desktopInactiveTabTextColor={this.props.item.inactive_tab_text_color?.value}
            desktopInactiveTabBackgroundColor={this.props.item.inactive_tab_background_color?.value}
            mobileActiveTabBackgroundColor={this.props.item.active_tab_background_color?.value}
            mobileActiveTabTextColor={this.props.item.active_tab_text_color?.value}
            mobileInactiveTabBackgroundColor={this.props.item.inactive_tab_background_color?.value}
            mobileInactiveTabTextColor={this.props.item.inactive_tab_text_color?.value}
            desktopBackgroundColor={this.props.item.active_tab_background_color?.value}
            mobileBackgroundColor={this.props.item.active_tab_background_color?.value}
          >
            {
              this.props.item.tab_slot_1 && (
                <SearchWidgetTabs.Tab
                  isFirst
                  label={getLanguageField(this.props.item.tab_slot_1.translations, this.props.selectedLanguage, "tab_title")}
                  icon={this.renderTabIcon(this.props.item.tab_slot_1, this.state.tab === 0)}
                  desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                  isLast={this.isLastTab(1)}
                >
                  <TabContent {...this.tabContentProps(this.props.item.tab_slot_1)} />
                </SearchWidgetTabs.Tab>
              )
            }
            {
              this.props.item.tab_slot_2 && (
                <SearchWidgetTabs.Tab
                  label={getLanguageField(this.props.item.tab_slot_2.translations, this.props.selectedLanguage, "tab_title")}
                  icon={this.renderTabIcon(this.props.item.tab_slot_2, this.state.tab === 1)}
                  desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                  isLast={this.isLastTab(2)}
                >
                  <TabContent {...this.tabContentProps(this.props.item.tab_slot_2)} />
                </SearchWidgetTabs.Tab>)
            }
            {
              this.props.item.tab_slot_3 && (
                <SearchWidgetTabs.Tab
                  label={getLanguageField(this.props.item.tab_slot_3.translations, this.props.selectedLanguage, "tab_title")}
                  icon={this.renderTabIcon(this.props.item.tab_slot_3, this.state.tab === 2)}
                  desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                  isLast={this.isLastTab(3)}
                >
                  <TabContent {...this.tabContentProps(this.props.item.tab_slot_3)} />
                </SearchWidgetTabs.Tab>)
            }
            {
              this.props.item.tab_slot_4 && (
                <SearchWidgetTabs.Tab
                  isLast={this.isLastTab(4)}
                  label={getLanguageField(this.props.item.tab_slot_4.translations, this.props.selectedLanguage, "tab_title")}
                  icon={this.renderTabIcon(this.props.item.tab_slot_4, this.state.tab === 3)}
                  desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                >
                  <TabContent {...this.tabContentProps(this.props.item.tab_slot_4)} />
                </SearchWidgetTabs.Tab>)
            }
          </SearchWidgetTabs>
        </div>
      </div>
    </>
  }

}